// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-helper-container {
  padding: 15px;
  position: absolute;
  height: 300px;
  width: 230px;
  top: 20px;
  left: -20px;
  background-color: white;
  z-index: 5;
  border: 1px solid gray;
  border-radius: 10px;
}

.badge-style {
  font-size: 14px;
  font-weight: 400;
  padding: 10px 0 !important;
  cursor: pointer;
  background-color: #4f8d96 !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/DateHelper/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,UAAU;EACV,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,oCAAoC;AACtC","sourcesContent":[".date-helper-container {\r\n  padding: 15px;\r\n  position: absolute;\r\n  height: 300px;\r\n  width: 230px;\r\n  top: 20px;\r\n  left: -20px;\r\n  background-color: white;\r\n  z-index: 5;\r\n  border: 1px solid gray;\r\n  border-radius: 10px;\r\n}\r\n\r\n.badge-style {\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  padding: 10px 0 !important;\r\n  cursor: pointer;\r\n  background-color: #4f8d96 !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
